import { formatarCNPJ as formatarCNPJUnificado } from "./cnpj";
import { formatarCPF as formatarCPFUnificado } from "./cpf";

export function formatarParaMoedaBRL(valor: number): string {
    return !valor ? '' : valor.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  // Delega para o utilitário unificado (src/utils/cnpj.ts), que já aceita CNPJ alfanumérico.
  export const formatarCNPJ = formatarCNPJUnificado;

  // Delega para o utilitário unificado (src/utils/cpf.ts).
  export const formatarCPF = formatarCPFUnificado;
  
  export const formatDate = (dateString: String) => {
    const day = dateString.toString().slice(6, 8);
    const year = dateString.toString().slice(0, 4);
    const month = dateString.toString().slice(4, 6);
  
    return `${day}/${month}/${year}`;
  };